import { cn } from '~/shadcn/lib/utils'
import { centsToEur } from '~/@lib/utils/money.utils'
import { CurrencyFormatter } from '~/@mid_ui/currency-formatter/CurrencyFormatter'
import { Text } from '~/@mid_ui/typography/Text'
import type { WalletSchema } from '~/@pages_investing/projects/_project_types/wallet.types'

type Props = {
  wallet: WalletSchema
}

function WalletInfo({ wallet }: Props) {
  return (
    <div className="flex flex-row w-full">
      <div
        className={cn(
          'h-[140px] flex-1 flex-wrap p-3 px-5 border border-border',
          'flex flex-col justify-between'
        )}>
        <div className="flex flex-row justify-between">
          <Text className="text-sm font-semibold leading-[21px]">
            Investičný účet
          </Text>
        </div>
        <CurrencyFormatter
          value={centsToEur(wallet?.funds?.available ?? 0)}
          className="self-end font-semibold"
          integerClassName="text-xl"
          decimalClassName="text-sm"
        />
      </div>
    </div>
  )
}

export { WalletInfo }
